import styled from 'styled-components';

export default styled.div`
  display: none;
  position: absolute;
  top: 9.7%;
  left: 6%;
  
  &.visible {
    display: block;
  }
`;